






































































































































































































import { Component } from "vue-property-decorator";
import PaginationComponent from "@/components/new_style_components/PaginationComponent.vue";
import PortalDate from "@/components/new_style_components/PortalDate.vue";
import PRILFilter from "@/dto/request/pril/PRILFilter";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import PRIL_DTO from "@/dto/request/pril/PRIL_DTO";
import { processError } from "@/utils/ComponentUtils";
import CreatePostalModal from "@/components/pril/CreatePostalModal.vue";
import DictionarySelect from "@/components/new_style_components/DictionarySelect.vue";
import { PRILStatus } from "@/constants/request/PRILConstants";
import { prettyEnum } from "@/utils/StringUtils";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import SimpleCompanySearch from "@/components/new_style_components/SimpleCompanySearch.vue";
import SublimeSearch from "@/components/new_style_components/SublimeSearch.vue";
import PersonDTO from "@/dto/person/PersonDTO";
import { namespace } from "vuex-class";
import moment from "moment";
import RouteNames from "@/router/RouteNames";
import PRILExtension from "@/mixins/PRILExtension";
import Auth from "@/state/Auth";
import { Role } from "@/constants/Role";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";

const AppModule = namespace("App");

@Component({
	components: {
		SimpleProfileSearch,
		PortalCheckbox,
		SublimeSearch,
		DictionarySelect,
		PaginationComponent,
		PortalDate,
		PortalSelect,
		SimpleCompanySearch,
	},
	computed: {
		PRILStatus() {
			return PRILStatus;
		},
		moment() {
			return moment
		}
	},
	methods: {
		prettyEnum
	}
})
export default class PostalList extends PRILExtension {
	@AppModule.State
	private isMobile!: boolean;

	private totalPages = 1;
	private countFilters = 0;
	private postalRegisterFilter = new PRILFilter();
	private postalList: Array<PRIL_DTO> = [];

	mounted(): void {
		this.loadPostalList();
	}

	loadPostalList(): void {
		Application.startLoading();
		PRILService.getLettersByFilter(this.postalRegisterFilter).then(
			resp => {
				this.postalList = resp.data.content;
				this.totalPages = resp.data.totalPages;
				Application.stopLoading();
			},
			error => processError(error, this)
		)
	}

	changePage(page: number): void {
		this.postalRegisterFilter.pageNumber = page;
		this.loadPostalList();
	}

	async resetFilters(): Promise<void> {
		this.postalRegisterFilter = new PRILFilter();
		this.countFilters = 0;
		await this.loadPostalList();
	}

	async confirmFilters(): Promise<void> {
		this.postalRegisterFilter.pageNumber = 1;
		this.countFilters = 0;
		for (let key in this.postalRegisterFilter) {
			if (key !== 'pageNumber' && key !== 'pageSize') {
				if (this.postalRegisterFilter[key as keyof PRILFilter]) {
					this.countFilters += 1;
				}
			}
		}
		await this.loadPostalList();
	}

	showCreatePostalModal(): void {
		this.$modal.show(CreatePostalModal,
			{
				callback: this.loadPostalList,
			},
			{
				width: this.isMobile ? 600 : 800,
			});
	}

	profileChanged(profile: ProfileDTO): void {
		this.postalRegisterFilter.customerId = profile.id;
	}

	createdByChanged(createdBy: PersonDTO): void {
		this.postalRegisterFilter.sender = createdBy.id;
	}

	assigneeChanged(assignee: PersonDTO): void {
		this.postalRegisterFilter.assignee = assignee.id;
	}

	getStyleDueDate(date: Date): string {
		const expirationDate = new Date(date);
		const today = new Date();
		const nextWeek = new Date();
		nextWeek.setDate(nextWeek.getDate() + 7);

		if (expirationDate < today) {
			return 'text-danger fw-bold';
		} else if (expirationDate < nextWeek) {
			return 'text-warning fw-bold';
		} else {
			return '';
		}
	}

	goToPostalRecord(record: PRIL_DTO): void {
		if(record.status === PRILStatus.NEW && !Auth.hasPermission(Role.PRIL_MANAGER)) {
			return; // the user has no permission to perform initial processing
		}
		if (!Auth.hasPermission(Role.PRIL_EXECUTOR)) {
			return; // the user has no permission to process the record
		}
		this.$router.push({ name: RouteNames.PRIL, params: { id: `${record.id}` }});
	}
}
